import React from 'react';
import { Box, Container } from '@mui/material';
import { COLOR_PURPLE } from 'styles/variables/colors';
import HeaderInformationMobile from '../HeaderInformationMobile';
import InstitutionsCommunicationMobile from 'components/InstitutionsCommunicationMobile';
import PharmaceuticalCompaniesMobile from 'components/PharmaceuticalCompaniesMobile';
import NextLink from 'next/link';
import CustomButton from 'components/CustomButton';
import PublishedSectionMobile from 'components/PublishedSectionMobile';
import ReferToAcademicInstitutionMobile from 'components/ReferToAcademicInstitutionMobile';
import CreatingScienceIllustrationsMobile from 'components/CreatingScienceIllustrationsMobile';
import BuildPresentationsMobile from 'components/BuildPresentationsMobile';

export default function PharmasContentMobile() {
  return (
    <>
      <Box py={1} bgcolor={COLOR_PURPLE} height={300}>
        <Container>
          <HeaderInformationMobile
            marginLeftPercentage={53}
            textTitle="For Pharmaceuticals & Biotechs"
            textDescription="Get in touch with our team to learn more about how Mind the Graph can assist you to save countless work hours. View some of our use cases in which other pharmaceuticals are already communicating science professionally."
          />
        </Container>
      </Box>

      <InstitutionsCommunicationMobile
        textTitle={
          <>
            The best infographic maker for <br /> communicating science visually
          </>
        }
        textInformation={
          <>
            Go straight to the point with Professional & Visually Appealing <br />
            infographics for science communication. Browse through 75,000+ <br />
            scientifically-accurate illustrations in more than 80 study fields.
          </>
        }
        textButton="Get More Professional"
      />

      <PharmaceuticalCompaniesMobile />

      <Box bgcolor="#FFFFFF" py={6}>
        <CreatingScienceIllustrationsMobile
          textTitle="Supplying your sales force with the most accurate science diagrams"
          textDescription={
            <>
              When it comes to science communication, an image can really be worth a Thousand words.
              Sometimes even more. Investing in scientifically accurate illustrations is essential
              forsetting the right tone for a good science-business conversation. After all,
              scientists know the difference between a rat and a mouse just by looking.
            </>
          }
        />

        <Box textAlign="center" pt={2}>
          <NextLink href={`/institutions/book-a-demo`} passHref={true}>
            <CustomButton>Book a Demo</CustomButton>
          </NextLink>
        </Box>
      </Box>

      <BuildPresentationsMobile />

      <PublishedSectionMobile titlePublished="Mind the Graph has been cited in many journals worldwide" />

      <ReferToAcademicInstitutionMobile
        textTitle={
          <>
            Refer Mind the Graph to a <br /> Pharma or Biotech company
          </>
        }
        textSubtitle={
          <>
            Refer the best science infographic maker as <br />
            an exclusive benefit to all associates
          </>
        }
        textInformation={
          <>
            Insert the person in charge's email <br />
            below and we'll get in touch
          </>
        }
      />
    </>
  );
}
